"use client";

const CheckIcon = () => (
  <svg
    className="ml-2 w-5 h-5"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default function PricingCard({
  features = [],
  name,
  unit,
  price,
  button = (
    <span className="text-white bg-gray-900 hover:bg-gray-700 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-8 dark:bg-gray-600 dark:text-white  dark:hover:bg-gray-500 dark:focus:ring-gray-600">
      Get started
    </span>
  ),
}: {
  features: string[];
  name: string;
  unit: string;
  price: string;
  button: JSX.Element;
}) {
  return (
    <div className="flex flex-col p-6 w-full text-center bg-white rounded-lg border border-gray-200 shadow xl:max-w-lg dark:border-gray-700 dark:bg-gray-800 xl:p-8">
      <h3 className="mb-4 text-2xl font-medium text-gray-900 dark:text-white">
        {name}
      </h3>
      <span className="text-5xl font-extrabold text-gray-900 dark:text-white">
        {price}

        <span className="text-xl">/{unit}</span>
      </span>
      {button}
      <ul
        role="list"
        className="space-y-4 text-left text-gray-900 dark:text-gray-400"
      >
        {features.map((label, index) => (
          <li className="flex items-center space-x-3">
            <CheckIcon />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
